<template>
  <div class="type-select">
    <div class="type-selects2">
      <div class="select-box3">
<!--        <span @click="dialogVisible=true" class="icon iconfont">-->
<!--          <img class="img" :src="require('@/assets/images/bianji.svg')" alt="" />-->
<!--          <img class="img active" :src="require('@/assets/images/bianji_cur.svg')" alt="" />-->
<!--        </span>-->

        <el-cascader
          size="small"
          v-model="valueMe"
          :options="getNewTree"
          :props="{
            value: 'id',
            label: 'name',
            checkStrictly: true,
            children: 'recursive_children',
          }"
          clearable
          @change="handleChange"
        ></el-cascader>
      </div>

      <el-dialog
        custom-class="dialog-type-select"
        title="模版分类编辑"
        :visible.sync="dialogVisible"
        width="457px"
        :append-to-body="true"
        :before-close="handleClose"
      >
        <el-tree
            ref="tree"
            class="tree-box"
            node-key="id"
            :data.sync="newData"
            :props.sync="props"
            :default-expanded-keys="[0]"
            v-loading.lock="loading"
            @check="check"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span
                  class="title"
                  :class="{first: `${data.id}` === '0'}"
            >
              <span class="add-icon"
                    :class="{first: `${data.id}` === '0'}"
                    v-if="authConfig.add && `${data.id}` !== '0'"
                    @click.stop="() => append(data, node)"
              >
                +
              </span>
              <span class="name">{{ node.label }}</span>
              <span
                v-if="`${data.id}` === '0'"
                class="angle el-tree-node__expand-icon el-icon-caret-right"></span>
            </span>
            <span
                class="btns">
                <span class="add-icon"
                      :class="{first: `${data.id}` === '0'}"
                      v-if="authConfig.add && `${data.id}` === '0'"
                      @click.stop="() => append(data, node)"
                >
                  +
                </span>
                <span
                    v-if="data.id !== 0 && authConfig.edit"
                    class="btn edit"
                    @click.stop="() => edit(data, node)"
                >编辑</span>
                <span
                    v-if="data.id !== 0 && authConfig.delete"
                    class="btn del"
                    @click.stop="() => remove(node, data)"
                >删除</span>
            </span>
          </span>
        </el-tree>
        <TypeName
          v-if="isTypeName"
          :title="isEdit?'编辑分类':'新建分类'"
          :visible.sync="isTypeName"
          :defaultValue.sync="nodeObj"
          @success="addTypeGo"
        />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import TypeName from './typeName'
import baseUrl from "@/utils/api";

export default {
  name: 'type-select2',
  components: {
    TypeName
  },
  props: {
    values: {
      type: Array,
      default: () => []
    },
    rootCatalog: String,
    isForm: Boolean, // 是否是表单
    type: String,
    formType: String,
    isShop: {
      type: Boolean,
      default: false
    },
    selectList: {
      type: Array,
      default: () => []
    },
    apiConfig: {
      type: Object,
      default: () => {
        return {
          addResourceCategoryOne: true,
          deleteResourceCategoryOne: true,
          updateResourceCategoryOne: true
        }
      }
    },
    authConfig: {
      type: Object,
      default: () => {
        return {
          add: true,
          edit: true,
          delete: true
        }
      }
    },
    data: Array
  },
  computed: {
    nodeObj () {
      const obj = {
        isEdit: this.isEdit,
        data: this.addTypeNode
      }
      return obj
    },
    getNewTree () {
      this.clearArrayEmpty(this.newData[0].childrens);
      return this.newData[0].childrens;
    }
  },
  watch: {
    isShop (vl) { this.newIsShop = vl },
    newIsShop (vl) { this.$emit('update:isShop', vl) },
    newData: {
      handler (vl) {
        this.$emit('update:data', vl)
      },
      deep: true,
      immediate: true
    },
    '$store.state.selectSchoolId': {
      handler (newValue, oldValue) {
        console.log('998877==>', newValue, oldValue)
        // this.$nextTick(() => {
        //   const fn = setTimeout(() => {
        //     this.init()
        //     clearTimeout(fn)
        //   }, 1000)
        // })
      },
      deep: true,
      immediate: true
    },
    selectList (vl) {
      this.newData[0].childrens = vl;
    },
  },
  created () {
    this.init()
    this.$nextTick(() => {
      // this.$refs.tree.setCurrentKey(0)
    })
  },
  data () {
    return {
      valueMe: this.values,

      loading: false,
      isEdit: false,
      newIsShop: this.isShop,
      select: '',
      props: {
        children: 'childrens',
        label: 'name'
      },
      newData: [
        {
          id: 0,
          name: this.rootCatalog || '所有分类',
          delete: true,
          childrens: []
        }
      ],

      addTypeNode: null, // 正在添加的节点
      isTypeName: false, // 添加分类名称
      dialogVisible: false // 编辑分类
    }
  },
  methods: {
    // 剔除空数组
    clearArrayEmpty (data) {
      data.forEach(val => {
        if (val.recursive_children) {
          if (val.recursive_children.length) {
            this.clearArrayEmpty(val.recursive_children);
          } else {
            val.recursive_children = undefined;
          }
        }
      });
    },
    init () {
      // this.flashData(true)
    },
    handleClose () {
      this.dialogVisible = false
    },
    handleChange (ids) {
      // console.log('handleChange==>', ids)
      this.$emit('onTypeSelect', { id: ids[ids.length - 1] }, this.getNewTree, this.formType || this.type)
    },
    async flashData (initial) {
      this.$http.get(`${baseUrl}/api/tags?equal[type]=commodity_course_category&equal[parent_id]=0&order[order]=asc`).then(res => {
        let data = res.items;

        // 表单处理
        if (this.isForm) {
          data = data.filter(v => v.type === this.type)
        }
        console.log('data....', data)
        this.newData[0].childrens = data
        console.log('分类树==>2', data)

        // 如果是初始化默认选择第一个分类
        if (initial) {
          try {
            this.$emit('onTypeSelectOne', { id: 0 })
            // this.currentChange({ id: 0 })
          } catch (e) {
            console.log('获取第一个分类失败==>', e)
          }
        }
      });
    },
    currentChange (data, node) {
      console.log('node==>', data, node)
      // 如果是最后一个叶子节点 请求数据
      // if (`${data.id}` !== '0') {
      // this.$emit('onTypeSelect', data, node, this.formType || this.type)
      // }
    },
    onEditName (name) {
      this.editNode.label = name
    },
    handleEdit (node, data) {
      console.log(node, data)
      this.isEditShow = true
      this.editName = data.name
      this.editNode = data
    },
    check () {
      // 获取选中节点数组
      const arr = this.$refs.tree.getCheckedNodes()
      this.form.newValue = arr

      this.isClearVilidate()
    },
    append (data) {
      this.isEdit = false
      this.addTypeNode = data
      this.isTypeName = true
    },
    edit (data) {
      this.isEdit = true
      this.addTypeNode = data
      this.isTypeName = true
    },
    addTypeGo ({ isEdit, name, description }) {
      this.addType({ isEdit, data: this.addTypeNode, name, description })
    },
    async addType ({ isEdit, data, name, description }) {
      // 游戏添加分类的话，有 'client' 或 'double_teacher'
      let type = this.type
      if (['game', 'game-type'].includes(type)) {
        type = this.isShop ? 'double_teacher' : 'client'
      }

      const obj = {
        type,
        // clientsId: this.$store.state.selectSchoolId,
        // sort: this.type,
        parent_id: data.id,
        name,
        // description
      };

      if (isEdit) {
        obj.id = this.nodeObj && this.nodeObj.data && this.nodeObj.data.id;
        obj.parent_id = this.nodeObj && this.nodeObj.data && this.nodeObj.data.parent_id;

        this.$http.patch(`${baseUrl}/api/tags/${obj.id}`, {
          name: obj.name
        }).then(res => {
          data.name = name;
          console.log('编辑成功==>', data, res);
        })
      } else {
        this.$http.post(`${baseUrl}/api/tags`, obj).then(res => {
          console.log('添加', res);

          const newChild = {
            id: res.data.id,
            name: res.data.name,
          }

          if (!data.childrens) {
            this.$set(data, 'childrens', []);
          }
          data.childrens.push(newChild);
          data.recursive_children = [newChild];
        });
      }
    },

    async remove (node, data) {
      this.loading = true;

      this.$http.delete(`${baseUrl}/api/tags/${data.id}`).then(() => {
          const parent = node.parent;
          const childrens = parent.data.childrens || parent.data;
          const index = childrens.findIndex(d => d.id === data.id);
          childrens.splice(index, 1);
      }).finally(() => {
        this.loading = false;
      });
      // const res = await CommonServer.default[this.apiConfig.delete]({
      //   id: data.id,
      //   clientsId: this.$store.state.selectSchoolId
      // })
      // console.log('分类名分类名=>2', res)
      // if (`${res.status_code}` === '200') {
      //   const parent = node.parent
      //   const childrens = parent.data.childrens || parent.data
      //   const index = childrens.findIndex(d => d.id === data.id)
      //   childrens.splice(index, 1)
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
.type-select{
  display: flex;
  flex-direction: column;
  align-items: center;
  /*width: 100%;*/
  float: left;

  .type-selects2{
    display: flex;
    flex-direction: row;
    align-items: center;
    //margin-top: 43px;
    //margin-left: 34px;

    .title{
      font-size: 14px;
      font-weight: 400;
      color: #333436;
      line-height: 14px;

      &.first{
        color: #333436;
      }
    }

    .select-box3{
      position: relative;

      .icon{
        /*background-color: red;*/
        width: 12px;
        height: 12px;
        display: inline-block;
        font-size: 12px;
        position: absolute;
        top: 10px;
        left: 16px;
        z-index: 10;
        margin-right: 10px;
        cursor: pointer;
        color: #9C9FA4;

        .active{display: none;}
        .img {
          float: left;
        }

        &:hover{
          color: #EFB600;

          .img{
            display: none;
            &.active{
              display: inline-block;
            }
          }

        }

        &:after{
          content: '';
          top: 0px;
          right: -12px;
          width: 1px;
          height: 14px;
          position: absolute;
          background: #DCDFE6;
        }
      }

      & /deep/ .el-input__inner{
        //padding-left: 50px;
      }
    }
  }

  .btns{
    .add{
      width: 16px;
      height: 11px;
      margin-left: 30px;
    }
    .edit{
      margin-left: 10px;
      color: #9f9f9f;
    }
    .del{
      width: 13px;
      height: 12px;
      margin-left: 10px;
    }
  }
}
</style>
<style lang="scss">
.dialog-type-select {
  .el-tree{width: 100%;}
  & /deep/ .el-dialog__header{
    border-bottom: 1px solid #E9E9E9;
  }

  & /deep/ .el-tree-node__content>.el-tree-node__expand-icon{
    padding: 6px 14px;
    margin-left: 10px;
  }
  & /deep/ .el-tree-node__expand-icon{
    color: #1A1C2B;
  }
  & /deep/ .el-tree-node__expand-icon.is-leaf{
    color: transparent;
  }

  & /deep/ .el-tree-node.is-expanded{
    .title.first .angle{
      transform: rotate(90deg);
    }
  }

  .title.first{
    position: relative;
    margin-left: 14px;

    .angle{
      margin-left: 20px;
      display: inline-block !important;
    }
  }
  & /deep/ .el-tree-node__children .el-tree-node__expand-icon.is-leaf + .custom-tree-node{
    .title {
      position: relative;
      left: -16px;

      .add-icon {
        position: relative;
        left: -8px;
        top: -1px;
      }
    }
  }

  & /deep/ .el-dialog__body .tree-box>.el-tree-node>.el-tree-node__content:first-child{
    .el-tree-node__expand-icon{
      display: none;
    }
  }

  .tree-box {
    margin-left: 40px;
    margin-right: 40px;
    width: inherit;

    .custom-tree-node{
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      position: relative;

      &>.title{
        position: relative;
        display: flex;
        align-items: center;
      }

      .btns{
        margin-right: 16px;

        .btn{
          font-size: 14px;
          font-weight: 400;
          color: #EEB500;
          line-height: 14px;
        }
      }

      .add-icon{
        position: absolute;
        left: -55px;
        top: 12px;
        width: 14px;
        height: 14px;
        line-height: 12px;
        text-align: center;
        display: inline-block;
        border-radius: 2px;
        border: 1px solid #333436;

        &.first{
          position: initial;
          background: #333436;
          color: white;
        }
      }
    }

    & /deep/ .el-tree-node__content {
      height: 40px;
      line-height: 40px;
      margin-bottom: 10px;
      background: #F5F7FA;
      border-radius: 4px;
    }

    & /deep/ .is-expanded > .el-tree-node__content {
      background: #E5E8F0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/typeSelect2/index.vue